module.exports = __webpack_public_path__ + "static/img/direct_hit_movie_thum_05_no_btn.bd0114e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/movie/direct_hit_movie_thum_05_no_btn.jpg
// module id = kl55
// module chunks = 0